import { Component } from '@angular/core';

@Component({
  selector: 'app-views-page',
  templateUrl: './views.component.html',
  styleUrls: ['./views.component.scss']
})
export class ViewsPageComponent {
  constructor() { }
}
